export type PushStatus = 'unknown' | 'no-content' | 'simple' | 'complex'

export const FETCH_SEGMENTS_ERR = 'Unable to display segments for prompter'
export const PUSH_ERR = 'Unable to push to prompter'
